module.exports = __webpack_public_path__ + "static/media/ambulance.fb5d6f41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ambulance.svg
// module id = 745
// module chunks = 0